import React from "react";
import styled from "styled-components";
import wave from "../images/bigWave.svg";

const WaveWr = styled.img`
  position: absolute;
  top: 290px;

  @media (max-width: 552px) {
    top: 190px;
  }
`;

export default function Wave() {
  return <WaveWr src={wave} alt="" />;
}
